import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Armchair, User, ChevronRight, ClipboardList } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { usePoll } from "@/hooks/usePoll";
import { api, rp, fmtTime } from "@/lib/api";
import { PageHeader, Empty, StageBadge } from "@/components/common";
import { FormDialog, TextField } from "@/components/Crud";

export default function Waiter() {
  const navigate = useNavigate();
  const { data } = usePoll("/bills", 8000, { status: "active" });
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ customer_name: "", table_name: "" });

  const create = async () => {
    const r = await api.post("/bills", form);
    toast.success(`Open bill ${r.data.code} dibuat`);
    setForm({ customer_name: "", table_name: "" });
    navigate(`/waiter/bill/${r.data.id}`);
  };

  return (
    <div>
      <PageHeader title="Open Bill" subtitle="Buat bill baru lalu pesan menu sesuai kode bill">
        <Button data-testid="open-bill-btn" onClick={() => setOpen(true)} className="h-11 rounded-xl bg-orange-600 px-5 hover:bg-orange-700 active:scale-95 transition-transform">
          <Plus className="mr-1 h-5 w-5" /> Open Bill Baru
        </Button>
      </PageHeader>
      {data?.length === 0 && <Empty icon={ClipboardList} text="Belum ada bill aktif. Klik Open Bill Baru untuk mulai." testId="waiter-empty" />}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3" data-testid="waiter-bill-list">
        {(data || []).map((b) => (
          <button key={b.id} data-testid={`waiter-bill-${b.code}`} onClick={() => navigate(`/waiter/bill/${b.id}`)}
            className="gm-rise group flex items-center gap-4 rounded-2xl border border-stone-200 bg-white p-4 text-left shadow-sm transition-colors hover:border-orange-300 hover:bg-orange-50/40 active:scale-[0.98]">
            <span className="grid h-14 w-14 shrink-0 place-items-center rounded-xl bg-[#1C1410] text-center text-white">
              <span><Armchair className="mx-auto h-4 w-4 text-orange-400" /><span className="block max-w-[52px] truncate text-xs font-bold">{b.table_name}</span></span>
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2"><span className="font-mono text-sm font-bold">{b.code}</span><StageBadge stage={b.stage} />{b.order_closed && <span data-testid={`waiter-bill-closed-${b.code}`} className="text-[11px] font-semibold text-zinc-500">Ditutup</span>}</div>
              <p className="mt-1 flex items-center gap-1 truncate text-sm text-zinc-600"><User className="h-3.5 w-3.5" />{b.customer_name}</p>
              <p className="text-xs text-zinc-400">{fmtTime(b.created_at)} · {b.items.length} item · {rp(b.totals.total)}</p>
            </div>
            <ChevronRight className="h-5 w-5 text-zinc-300 group-hover:text-orange-500" />
          </button>
        ))}
      </div>
      <FormDialog testId="open-bill-dialog" open={open} onOpenChange={setOpen} title="Open Bill Baru" onSubmit={create}>
        <TextField label="Nama Pelanggan" testId="open-bill-customer-input" required value={form.customer_name} onChange={(e) => setForm({ ...form, customer_name: e.target.value })} placeholder="Contoh: Budi" />
        <TextField label="Nama / Nomor Meja" testId="open-bill-table-input" required value={form.table_name} onChange={(e) => setForm({ ...form, table_name: e.target.value })} placeholder="Contoh: Meja 5" />
      </FormDialog>
    </div>
  );
}
